import React, {useContext} from 'react';
import {Avatar, Image, Row, Col, Card} from 'antd';
import _ from 'lodash';
import {useAuthStore} from '@/context/auth';
import classNames from 'classnames';
import styles from './view.module.less';
import MsgContext from '../msgContext';
import ReactPlayer from 'react-player';
import {FileTextOutlined, LinkOutlined} from '@/icons';

export default function View() {
    const {viewText, viewLinks, viewImages, viewFiles, viewVideos, viewWebApps} = useContext(
        MsgContext
    );
    const [authStore] = useAuthStore();
    const name = _.get(authStore, 'user.name');
    const avatar = _.get(authStore, 'user.avatar');
    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <h3 className={styles.name}>{name}</h3>
            </div>
            <Row style={{margin: '20px 0'}}>
                {!_.isEmpty(viewText) && (
                    <Col span={24}>
                        <div className={styles.avatar}>
                            <Avatar src={avatar} shape="square" size="large" />
                        </div>
                        <div className={styles.content}>
                            <div className={styles.view}>
                                {viewText}
                                <div className={classNames(styles.tri, styles.left)} />
                            </div>
                        </div>
                    </Col>
                )}
                {viewLinks.length > 0 &&
                    viewLinks.map((link, key) => (
                        <Col span={24} key={key}>
                            <div className={styles.avatar}>
                                <Avatar src={avatar} shape="square" size="large" />
                            </div>
                            <div className={styles.content}>
                                <div className={styles.view}>
                                    <p className={styles.title}>{link.title}</p>
                                    <div className={styles.url}>
                                        <div className={styles.label}>{link.url}</div>
                                        <div>
                                            <Avatar
                                                src={link.picurl}
                                                // icon={<LinkOutlined />}
                                                shape="square"
                                                size="large"
                                                // style={{backgroundColor: '#8cbfef'}}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className={classNames(styles.tri, styles.left)} />
                            </div>
                        </Col>
                    ))}
                {viewImages.length > 0 &&
                    viewImages.map((image, key) => (
                        <Col span={24} key={key}>
                            <div className={styles.avatar}>
                                <Avatar src={avatar} shape="square" size="large" />
                            </div>
                            <div className={styles.content}>
                                <Image src={image.urls.file} width={200} />
                            </div>
                        </Col>
                    ))}
                {viewFiles.length > 0 &&
                    viewFiles.map((file, key) => (
                        <Col span={24} key={key}>
                            <div className={styles.avatar}>
                                <Avatar src={avatar} shape="square" size="large" />
                            </div>
                            <div className={styles.content}>
                                <div className={styles.view}>
                                    <div className={styles.file}>
                                        <div className={styles.label}>{file.fileName}</div>
                                        <div>
                                            <Avatar
                                                icon={<FileTextOutlined />}
                                                shape="square"
                                                size="large"
                                                style={{
                                                    backgroundColor: '#36ad4d',
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className={classNames(styles.tri, styles.left)} />
                                </div>
                            </div>
                        </Col>
                    ))}
                {viewVideos.length > 0 &&
                    viewVideos.map((video, key) => (
                        <Col span={24} key={key}>
                            <div className={styles.avatar}>
                                <Avatar src={avatar} shape="square" size="large" />
                            </div>
                            <div className={styles.content}>
                                <ReactPlayer
                                    controls
                                    playing={false}
                                    url={video.urls.file}
                                    height={100}
                                    width={200}
                                />
                            </div>
                        </Col>
                    ))}
                {viewWebApps.length > 0 &&
                    viewWebApps.map((webApp, key) => (
                        <Col span={24} key={key}>
                            <div className={styles.avatar}>
                                <Avatar src={avatar} shape="square" size="large" />
                            </div>
                            <div className={styles.content}>
                                <Card
                                    hoverable
                                    style={{width: 200}}
                                    cover={
                                        <img
                                            alt="example"
                                            style={{width: 200, height: 100, objectFit: 'cover'}}
                                            src={webApp.pic_url}
                                        />
                                    }
                                >
                                    <Card.Meta title={webApp.title} />
                                </Card>
                            </div>
                        </Col>
                    ))}
            </Row>
        </div>
    );
}
